import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import Navbar from "@/components/site/Navbar";
import Footer from "@/components/site/Footer";
import Home from "@/pages/Home";
import WorkPage from "@/pages/WorkPage";
import WorkDetail from "@/pages/WorkDetail";
import ServicesPage from "@/pages/ServicesPage";
import AboutPage from "@/pages/AboutPage";
import ContactPage from "@/pages/ContactPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import { AuthProvider } from "@/lib/auth";

function ScrollToTop() {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "instant" });
    }, [pathname]);
    return null;
}

function Shell() {
    const { pathname } = useLocation();
    const isAdmin = pathname.startsWith("/admin");
    return (
        <>
            {!isAdmin && <Navbar />}
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/work" element={<WorkPage />} />
                <Route path="/work/:slug" element={<WorkDetail />} />
                <Route path="/services" element={<ServicesPage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/admin/login" element={<AdminLogin />} />
                <Route path="/admin" element={<AdminDashboard />} />
            </Routes>
            {!isAdmin && <Footer />}
        </>
    );
}

function App() {
    return (
        <div className="App grain-overlay">
            <AuthProvider>
                <BrowserRouter>
                    <ScrollToTop />
                    <Shell />
                    <Toaster
                        position="bottom-right"
                        theme="dark"
                        toastOptions={{
                            style: {
                                background: "#0a0a0a",
                                color: "#fff",
                                border: "1px solid rgba(255,255,255,0.08)",
                                borderRadius: 2,
                            },
                        }}
                    />
                </BrowserRouter>
            </AuthProvider>
        </div>
    );
}

export default App;
